import { useState } from "react";
import { useNavigate } from "react-router-dom";
// @mui
import {
  Link,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from "../../../components/iconify";
import axios from "axios";

// ----------------------------------------------------------------------

export default function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);

  const handleClick = () => {
    setError(null);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/admin/login`, {
        email,
        password,
      })
      .then(function (response) {
        localStorage.setItem("token", response.data.token);
        window.location.href = "/";
      })
      .catch(function (error) {
        console.log('🚀 ~> error:', error)
        setError(error.response?.data || error?.message || "Something went wrong");
      });
  };

  return (
    <>
      <Stack spacing={3}>
        {error !== null ? (
          <Alert sx={{ marginBottom: 2 }} severity="error">
            {error}
          </Alert>
        ) : null}

        <TextField
          name="email"
          label="Email address"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />

        <TextField
          name="password"
          label="Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  <Iconify
                    icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ my: 2 }}
      ></Stack>

      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        onClick={handleClick}
        disabled={email.length === 0 || password.length === 0}
      >
        Login
      </LoadingButton>
    </>
  );
}
